export default __webpack_public_path__ + "static/media/watermark.8f06f0ba.png";